// Currency-aware number formatter. Was hardcoded to THB; now takes the
// store's currency code (falls back to THB for any unrecognized/missing
// value, same as client/src/utils/currency.js).
const formatters = {};

export const format = (value, currencyCode = 'THB') => {
  const code = currencyCode || 'THB';
  if (!formatters[code]) {
    formatters[code] = new Intl.NumberFormat('hi-IN', {
      style: 'currency',
      currency: code,
    });
  }
  return formatters[code].format(value);
};
